var render = function render(_c,_vm){return _c('form-group',{class:[_vm.data.staticClass, {'error' : _vm.props.v ? _vm.props.v.$error : null}],attrs:{"label":_vm.props.label,"help":_vm.props.help}},[_c('textarea',{staticClass:"form-control",class:_vm.props.inputClass,attrs:{"rows":_vm.props.rows ? _vm.props.rows : 5,"type":_vm.props.type ? _vm.props.type: 'text',"placeholder":_vm.props.placeholder,"disabled":_vm.props.disabled,"readonly":_vm.props.readonly},domProps:{"value":_vm.props.value},on:{"input":($event) => {
                  _vm.listeners.input && _vm.listeners.input($event.target.value);
                  if(_vm.props.v){
                       _vm.props.v.$touch();
                  }
              }}})])
}
var staticRenderFns = []

export { render, staticRenderFns }